export default {
    init() {
        $(document).ready(function () {
            $('.profiles').find('.description').matchHeight();
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/profile.js